module.exports = __webpack_public_path__ + "static/media/fiveinfive.b00fe352.jpg";